export const storeModule = {
  namespaced: true,
  state: () => ({
    filtersShown: false,
  }),
  mutations: {
    setFiltersShown(st, filtersShown) {
      st.filtersShown = filtersShown;
    },
  },
};

export default (store) => {
  store.registerModule('search', storeModule);
};
